import React, { useRef } from 'react';
import { Formik, Form } from 'formik';
import { ImageIllustrationUpload } from '../Image/ImageIllustrationUpload';
import styles from "../../pages/Seances/SeancePage.module.css";

const RenderCellLogo = ({ value, row, handleSubmitLogo }) => {
    const fileInputRef = useRef(null);

    const handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleSubmitLogoWithRow = (values, actions) => {
        handleSubmitLogo(values, { ...actions, row });
    };

    return (
        <>
            <ImageIllustrationUpload src={value} alt={"logo"} onClick={handleClick} />
            <Formik
                initialValues={{ file: null }}
                onSubmit={handleSubmitLogoWithRow}
            >
                {({ setFieldValue, submitForm, isSubmitting, errors }) => (
                    <Form style={{ display: "flex", flexDirection: "column" }}>
                        <input
                            id={`file-${row.id}`}
                            className={styles.inputFileLogo}
                            name="file"
                            type="file"
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            onChange={(event) => {
                                setFieldValue("file", event.currentTarget.files[0]);
                                submitForm();
                            }}
                        />
                        {errors.file ? <div style={{ color: 'red' }}>{errors.file}</div> : null}
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default RenderCellLogo;
